import { ReactComponent as CheckSvg } from '../../assets/check-icon.svg';

import { IconWrapper } from './iconWrapper';
import { IconProps } from './model';

export const CheckIcon = (props: IconProps) => {
    return (
        <IconWrapper {...props}>
            <CheckSvg />
        </IconWrapper>
    );
};
